export enum TenantStatusFlags {
  None = 0,
  Hidden = 1 << 0,
  OverrideReconcileLock = 1 << 1,
  EarlyPayrollWeek = 1 << 2
}

export const TenantStatusFlagsMapping: Record<TenantStatusFlags, string> = {
  [TenantStatusFlags.None]: 'None',
  [TenantStatusFlags.Hidden]: 'Hidden',
  [TenantStatusFlags.OverrideReconcileLock]: 'Override Reconcile Lock',
  [TenantStatusFlags.EarlyPayrollWeek]: 'Early Payroll Week'
};
